var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "main", staticClass: "scroller js-scroller" }, [
    _c("div", { ref: "header", staticClass: "scroller__heading" }, [
      _c("div", { ref: "title", staticClass: "scroller__padder" }, [
        _c(
          "h2",
          { staticClass: "app__title app__title--nostyle bged" },
          [_vm._t("title", [_vm._v(_vm._s(_vm.title))])],
          2
        )
      ]),
      _c(
        "div",
        { ref: "image", staticClass: "scroller__padder" },
        [_vm._t("header")],
        2
      )
    ]),
    _c(
      "div",
      { ref: "scroller", staticClass: "scroller__content" },
      [_vm._t("content")],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-66dd0a7a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66dd0a7a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/shared/components/scrolling-table.vue
// module id = 172
// module chunks = 4